import React, { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import ReactTooltip from "react-tooltip";
import MaterialTableTS from "../../../../components/tables/MaterialTableTS";
import { useRecoilState} from "recoil";
import { agmtRowData } from "../atoms/atoms";
interface PolicyPrefixModalProps {
  isOpen: boolean;
  onClose: (value: boolean) => void;
}

export const PolicyPrefixModal: React.FC<PolicyPrefixModalProps> = ({
  isOpen,
  onClose,
}) => {
  const policyPrefixColumn = [
    {field: "policyPrefix"},
  ];

const [agmtDetails] = useRecoilState(agmtRowData);
const policyPrefixData =
  (agmtDetails.policyPrefix as string | undefined)?.split(',')
  .map(a => ({policyPrefix: a.trim()})) || [];

  return (
    <>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog
          as="div"
          className="z-50 overflow-visible fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity opacity-100"
          onClose={() => {}}
        >
          <div className="flex items-center justify-center fixed inset-0 overflow-visible">
            <div className="flex items-center justify-center p-2 overflow-visible">
              <Dialog.Panel
                className="max-w-xxl h-1/2 transform overflow-visible rounded-lg bg-white p-3 
               shadow-xl transition-all"
              >
                <>
                  <ReactTooltip
                    id="closeIcon"
                    place="right"
                    type="light"
                    effect="solid"
                  />
                  <button
                    data-tip="Close"
                    data-for="closeIcon"
                    data-class="text-xxs whitespace-pre px-0"
                    onClick={() => onClose(false)}
                    className={`absolute z-50 -right-2 -top-2`}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      className="w-7 h-7 text-octonary cursor-pointer"
                    >
                      <path
                        fillRule="evenodd"
                        d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm-1.72 6.97a.75.75 0 10-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 101.06 1.06L12 13.06l1.72 1.72a.75.75 0 101.06-1.06L13.06 12l1.72-1.72a.75.75 0 10-1.06-1.06L12 10.94l-1.72-1.72z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </button>
                </>
                <Dialog.Title className="pb-2">
                  <div className="font-bold text-primary text-md">
                    Policy Prefix
                  </div>
                  <div className="w-full border-b-2 border-secondary my-1" />
                </Dialog.Title>
                <div className="text-xs max-h-fit">
                  <MaterialTableTS
                    data={policyPrefixData}
                    isLoading={false}
                    columns={policyPrefixColumn}
                    showHeader={false}
                  />
                </div>
              </Dialog.Panel>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};